import {
  CsvExport,
  ExcelExport,
  ExcelSheet,
} from '../models/api/core/export/export';
import { ExportFormatterUtil } from './export-formatter.util';

export class InvoiceLineExportMapper {
  static toCsvExport(rows: any[], fileName: string): CsvExport {
    const headers = this.getHeaders();
    const dataRows = this.mapRowsToExportData(rows);

    return {
      fileName,
      headers,
      rows: dataRows,
    };
  }

  static toExcelExport(
    rows: any[],
    fileName: string,
    sheetLabel: string,
  ): ExcelExport {
    const headers = this.getHeaders();
    const dataRows = this.mapRowsToExportData(rows);

    const sheet: ExcelSheet = {
      label: sheetLabel,
      headers,
      rows: dataRows,
    };

    return {
      fileName,
      sheets: [sheet],
    };
  }

  private static getHeaders(): string[] {
    return [
      'Claim Number',
      'Claimant Name',
      'Contract Number',
      'Contract Name',
      'Internal Control Number',
      'Invoice',
      'Line Number',
      'Service Begin Date',
      'Service End Date',
      'Billed Amount',
      'Fee Schedule Reduction',
      'PPO Reduction',
      'Negotiated Discount',
      'Recommended Allowance',
      'Pay Code',
      'Service National Provider Identifier',
      'Service Type',
      'Procedure Code Billed',
      'Procedure Code Paid',
      'Billed Quantity',
      'Procedure Description',
      'Location',
      'Line Fee',
    ];
  }

  private static mapRowsToExportData(rows: any[]): any[][] {
    return rows.map((row) => [
      row.claimNumber || '',
      row.claimantName || '',
      row.contractNumber || '',
      row.contractName || '',
      row.icn || '',
      row.invoice || '',
      row.lineNum || '',
      ExportFormatterUtil.formatDate(row.dosBegin),
      ExportFormatterUtil.formatDate(row.dosEnd),
      ExportFormatterUtil.formatCurrency(row.billedAmount),
      ExportFormatterUtil.formatCurrency(row.feeReduction),
      ExportFormatterUtil.formatCurrency(row.ppoReduction),
      ExportFormatterUtil.formatCurrency(row.otherReduction),
      ExportFormatterUtil.formatCurrency(row.recAmount),
      row.payCode || '',
      row.serviceNPI || '',
      row.serviceType || '',
      row.procCodeBilled || '',
      row.procCodePaid || '',
      row.billedQty || '',
      row.procDescr || '',
      row.serviceLocation || '',
      ExportFormatterUtil.formatCurrency(row.lineFee),
    ]);
  }
}
